import { createConfirmation } from 'react-confirm';
import Confirmation from './Confirmation';
 
// create confirm function
const confirm = createConfirmation(Confirmation);
 
// This is optional. But I recommend to define your confirm function easy to call.
export default function(confirmation, options = {}) {
  // You can pass whatever you want to the component. These arguments will be your Component's props
  console.log(confirm, confirmation)
  return confirm({ confirmation, ...options });
}